export var Mode;

(function (Mode) {
  Mode["loadMore"] = "loadMore";
  Mode["pagination"] = "pagination";
  Mode["search"] = "search";
})(Mode || (Mode = {}));